/* import __COLOCATED_TEMPLATE__ from './base-chart.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import $ from 'jquery';
import PrettyNum from '../../utils/pretty-num-wrapper';
import Formulas from '../../utils/formulas';

export default class BaseChart extends Component {
    layoutName = 'components/charts/base-chart';
    tagName = '';

    @service('data') model;

    zoomFit = false;
    updateAppData = () => {};

    init() {
        super.init();
        this.removeLegendIndexes = [];
    }

    @action performZoomFit() {
        this.set('model.zoomFitScaling', true);
        if (this.updateAppData) this.updateAppData();
    }

    @action resetZoom() {
        this.plot.resetZoom();
        this.onZoomOut();
    }

    @action pointerDown() {
        if (window.getSelection && window.getSelection().empty) {
            window.getSelection().empty();
        }
    }

    enableZoom(plot) {
        this.set('zoomed', false);
        this.set('plot', plot);

        let t = plot.target;

        t.off('jqplotZoom', this.onZoomIn);
        t.off('dblclick', this.onZoomOut);
        t.on('jqplotZoom', $.proxy(this.onZoomIn, this));
        t.on('dblclick', $.proxy(this.onZoomOut, this));

        t.addClass('zoom-enabled');
        this.setCssForZoom();
    }

    // Align the magnifying glass on zoomable charts.
    setCssForZoom() {
        let eventCanvas = this.plot.target.find('> canvas.jqplot-event-canvas');
        let top = parseFloat(eventCanvas.css('top'));
        let left = parseFloat(eventCanvas.css('left'));

        eventCanvas.css({ top: top - 9, left: left - 10, 'z-index': 0 });
    }

    onZoomIn() {
        this.set('zoomed', true);
        this.set('justZoomed', true);
        this.setCssForZoom();
        this.trimLegend();
    }

    onZoomOut() {
        this.set('zoomed', false);
        this.setCssForZoom();
        this.trimLegend();
    }

    trimLegend() {
        Object.values(document.querySelectorAll(`#${this.chartId} tr.jqplot-table-legend`))
            .filter(
                (item) =>
                    !(item && item.children.length === 2 && item.children[1].textContent) ||
                    item.children[1].textContent.includes('Series'),
            )
            .forEach((item) => item.remove());
    }

    // Formatters
    numberTickFormatter(format, val) {
        return '<span class="plot-tooltip">' + Math.round(val * 100) / 100 + '</span>';
    }

    preciseNumberTickFormatter(format, val) {
        return '<span class="plot-tooltip">' + Math.round(val * 10000) / 10000 + '</span>';
    }

    roundingTickFormatter(format, val) {
        return '<span class="plot-tooltip">' + val.toFixed(2) + '</span>';
    }

    prettyTickFormatter(format, val) {
        return `<span class="plot-tooltip">${PrettyNum.eng3(val)}</span>`;
    }

    roundToNsPrettyTickFormatter(format, val) {
        return `<span class="plot-tooltip">${PrettyNum.roundToNs(val)}</span>`;
    }

    stringTickFormatter(format, val) {
        return '<span class="plot-tooltip">' + val + '</span>';
    }

    baseFormatter(format, val) {
        return val;
    }

    // For log axes
    setLogTicks(start, stop) {
        let subDecadeVal,
            decadeVal,
            valString,
            result = [];

        subDecadeVal = start;
        decadeVal = start;

        while (subDecadeVal < stop) {
            if (subDecadeVal == decadeVal) {
                valString = PrettyNum.eng3(decadeVal);
                result.push([subDecadeVal, valString]);
            } else {
                valString = '';
                result.push([subDecadeVal, valString]);
            }

            decadeVal = Formulas.getDecade(subDecadeVal);
            subDecadeVal = Formulas.getSubDecade(subDecadeVal);
        }

        valString = PrettyNum.eng3(stop);
        result.push([stop, valString]);

        return result;
    }
}
